export default {
  contact: {
    description: 'Return a list of my contact information.',
    list: [
      {
        type: 'info',
        label: 'Email:',
        content: '`zxuhan7@gmail.com`'
      },
      {
        type: 'info',
        label: 'Github:',
        content: '`https://github.com/zxuhan`'
      }
    ]
  },
  skill: {
    description: 'Return a list of my skills and my rating of them.',
    list: [
      { type: 'success', label: 'A', content: '· Java 95/100' },
      { type: 'success', label: 'A', content: '· Python 80/100' },
      { type: 'success', label: 'A', content: '· Go 80/100' },
      { type: 'success', label: 'A', content: '· Kotlin 80/100' },

      { type: 'warning', label: 'B', content: '· TypeScript 70/100' },
      { type: 'warning', label: 'B', content: '· JavaScript 70/100' },
      { type: 'warning', label: 'B', content: '· C 70/100' },
      { type: 'warning', label: 'B', content: '· C++ 70/100' },

      { type: 'error', label: 'C', content: '· Shell 60/100' },
      { type: 'error', label: 'C', content: '· Lua 60/100' },

      { type: 'black', label: 'D', content: '· CSS -999/100' }
    ]
  },
  movie: {
    description: 'Return a list of movies that I have watched.',
    list: [
      ' 《 Inception 》',
      ' 《 John Wick 》',
      ' 《 The Dark Knight 》',
      ' 《 Dunkirk 》',
      ' 《 Before Sunrise 》',
      ' 《 The Godfather 》',
      ' 《 The Bourne Identity 》',
      ' 《 La La Land 》',
      ' 《 How to Lose a Guy in 10 Days 》',
      ' 《 Harry Potter 》',
      ' 《 10 Things I Hate About You 》',
      ' 《 Pirates of the Caribbean 》',
      ' 《 Catch Me If You Can 》'
    ]
  },
  tv: {
    description: 'Return a list of TV series that I have watched.',
    list: [
      ' 《 Game of Thrones 》',
      ' 《 House of the Dragon 》',
      ' 《 How I Met Your Mother 》',
      ' 《 Peaky Blinders 》',
      ' 《 The Crown 》',
      " 《 The Queen's Gambit 》",
      ' 《 Normal People 》',
      ' 《 Narcos 》',
      ' 《 Sherlock 》',
      ' 《 Why Women Kill 》',
      ' 《 Prison Break 》',
      ' 《 Gossip Girl 》',
      ' 《 Dark 》'
    ]
  }
}
